import script from "./CommonInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonInput.vue?vue&type=script&setup=true&lang=ts"

import "./CommonInput.vue?vue&type=style&index=0&id=a1e78dd6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1e78dd6"]])

export default __exports__